import "../../scss/forms.scss";
import "../../scss/modal.scss";
import "./_style.scss";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "react-select/dist/react-select.min.css";

import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import { toast } from "react-toastify";

import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Spinner,
} from "reactstrap";
import { bindActionCreators } from "redux";

import {
    FiltroDinamico,
    GridDinamico,
    removeFromDataByProp,
    removePropByProp,
    selectAllOnGrid,
    updateRemoteOptionsThroughFilters,
    updateItemData,
    updateDataByIds,
    dynamicFilterStore,
} from "@newspacebpo/newspace-react-grid-filter-bfveic";

import { ContextLoader } from "../ContextLoader";
import { getTotaisProtocolo } from "../../services/protocolos";
import { MAX_ITENS_POR_PROTOCOLO, PROTOCOLO_ERROS_MENSAGENS } from "../../constants/protocolo";
import warning from "../../assets/img/brand/warning.svg";
import PaginationControl from "../UI/paginationControl";
import { SelectAllAction } from "../SelectAllAction";
import { LOGS } from "../../constants/logs";
import { ROLES } from "../../constants/roles";
import { defaultTableOptions } from "../../constants/tableOptions";
import { userHasRole } from "../../services/role";
import * as storage from "../../services/storage";
import * as trackTime from "../../services/tracking-time";
import { redirectHandled, getSystemName } from '../../util/helper'
import * as authActions from "../../store/auth/actions";
import * as logsActions from "../../store/ducks/r_logs/actions";
import * as EnvioActions from "../../store/ducks/protocolo/envio/actions";

import { queryBuilder } from "../../util/routeActions";
import ModalDocumentosPendentes from "./components/ModalDocumentosPendentes";
import ModalExclusaoSucesso from "./components/ModalExclusaoSucesso";
import ModalConfirmarRemoverContratoDoProtocolo from "./components/ModalConfirmarRemoverContratoDoProtocolo";
import ModalEnviarProtocolo from "./components/ModalEnviarProtocolo";
import ModalDevolucaoDocumentos from "./components/ModalDevolucaoDocumentos";
import ModalConfirmarExclusao from "./components/ModalConfirmarExclusao";
import ModalProtocoloExcluidoSucesso from "./components/ModalProtocoloExcluidoSucesso";
import ModalProtocoloInvalido from "./components/ModalProtocoloInvalido";
import ModalGeracaoProtocolo from "./components/ModalGeracaoProtocolo";
import { ProtocoloMassa } from "./components/ProtocoloMassa";

const modo = {
    protocolo_principal: {
        title: "Tipo Principal",
        modalDocumentos: false,
        escondeContrato: false,
        escondeProposta: true,
        colunaResult: "contrato",
        colunaResultPlural: "contratos",
    },
    protocolo_complemento: {
        title: "Complemento/Regularização",
        modalDocumentos: false,
        escondeContrato: false,
        escondeProposta: true,
        colunaResult: "contrato",
        colunaResultPlural: "contratos",
        widthActions: "120px",
    },
    protocolo_cancelado: {
        title: "Cancelado/Recusado",
        modalDocumentos: false,
        escondeContrato: false,
        escondeProposta: true,
        colunaResult: "contrato",
        colunaResultPlural: "contratos",
        widthActions: "120px",
    },
    protocolo_consignado: {
        title: "Cartão Consignado",
        modalDocumentos: false,
        escondeContrato: false,
        escondeProposta: true,
        colunaResult: "contrato",
        colunaResultPlural: "contratos",
        widthActions: "120px",
    },
};

class EnvioFiname extends React.Component {
  constructor(props) {
    super(props);

    this.options = {
      ...defaultTableOptions,
      paginationShowsTotal: () => 'Mostrar ',
      alwaysShowAllBtns: true,
      withFirstAndLast: true,
      hideSizePerPage: false,
      sizePerPage: MAX_ITENS_POR_PROTOCOLO,
      tipo: this.props.match
        ? `protocolo_${ this.props.match.params.tipoProtocolo }`
        : 'protocolo_principal',
      onPageChange: this.onPageChange,
      onSizePerPageList: this.onSizePerPageList,
      afterTableComplete: this.handleTableComplete,
    };

    this.state = {
        sizePage: MAX_ITENS_POR_PROTOCOLO,
        options: this.options,
        submitProtocolotButton: false,
        modalDocumentosPedentes: false,
        modalConfirmarRemoverContratoDoProtocolo: false,
        modalExcluirProtocolo: false,
        modalProtocoloSucesso: false,
        modalExcluirProtocoloSucesso: false,
        modalComplementoRegularizacao: false,
        modalContratoExcluidoSucesso: false,
        modalEnvelope: false,
        modalInsercaoBloqueio: false,
        modalDevolucaoDocumentos: false,
        valueEnvelope: "",
        valueContratoModal: "",
        contratoBloqueado: {},
        contratoDocumentosPendentes: {},
        url: "/contrato/consulta/visualizar/",
        url_protocolo: "protocolo/consulta/visualizar/",
        url_exclusao: "protocolo/excluir?contrato=",
        erroProtocolo: false,
        searchParams: {},
        shouldShowProcoloMassa: false,
        incluidos: [],
        nomeSistema: "",
    };

    this.protocoloBloqueado = null;
    this.toggleModalInsercaoBloqueio = this.toggleModalInsercaoBloqueio.bind(this);
    this.toggleModalExcluirProtocolo = this.toggleModalExcluirProtocolo.bind(this);
    this.deleteProtocolo = this.deleteProtocolo.bind(this);
    this.checkEnviarProtocolo = this.checkEnviarProtocolo.bind(this);
    this.toggleModalEnvelope = this.toggleModalEnvelope.bind(this);
    this.handleKeyPressEnvelop = this.handleKeyPressEnvelop.bind(this);
    this.updateEnvelopeValue = this.updateEnvelopeValue.bind(this);
    this.enviarProtocolo = this.enviarProtocolo.bind(this);
    this.visualizarContrato = this.visualizarContrato.bind(this);
    this.toggleModalProtocoloSucesso = this.toggleModalProtocoloSucesso.bind(this);
    this.onChangeFilterLoja = this.onChangeFilterLoja.bind(this);
    this.onChangeFilterProduto = this.onChangeFilterProduto.bind(this);
    this.onChangeFilterPromotora = this.onChangeFilterPromotora.bind(this);
    this.adicionar = this.adicionar.bind(this);
    this.removerContratoDoProtocolo = this.removerContratoDoProtocolo.bind(this);
    this.customActions = this.customActions.bind(this);
    this.openPendencias = this.openPendencias.bind(this);
    this.getDocumentosPedentes = this.getDocumentosPedentes.bind(this);
    this.toggleModalDocumentosPedentes = this.toggleModalDocumentosPedentes.bind(this);
    this.onOpenProtocoloMassa = this.onOpenProtocoloMassa.bind(this);
    this.onValidateProtocoloMassa = this.onValidateProtocoloMassa.bind(this);
    this.onCloseErrorProtocoloMassa = this.onCloseErrorProtocoloMassa.bind(this);
    this.onCloseProtocoloMassa = this.onCloseProtocoloMassa.bind(this);
    this.redirectExcluirProtocolo = this.redirectExcluirProtocolo.bind(this);
  }
    componentDidUpdate(prevProps) {
        const { envio } = this.props;
        if (!envio) return;

        const { resetProtocolo } = envio;

        const incluidosStorage = this.obterContratosIncluidosStorage();

        if (incluidosStorage && (prevProps.envio.incluidos.length < incluidosStorage.length)) {
            this.props.envio.incluidos = incluidosStorage
            this.carregasInfos()
        }

        if (resetProtocolo) {
            this.encerrandoProtocolo();
        }
    }

    onSizePerPageList(sizePerPage) {
        this.setState({ options: { ...this.options, sizePerPage } });
        this.props.actions.clearSelected();
    }

    handleTableComplete() {
        if (this._gridProtocolo) this.props.actions.clearSelected();
    }

    redirectImpressao() {
        if (this.props.envio.redirectImpressao) {
            this.limpar();
            this.limparProtocolo();

            // Redireciona para a impressao quando gerado o protocolo
            redirectHandled(this.props.history, `${this.state.url_protocolo}/${this.props.envio.protocoloFinalizadoNumero}`);
        } else {
            toast.warning("Protocolo esta sendo carregado. Aguarde...");
        }
    }

    async componentDidMount() {
        const {
            history,
            location: { search },
            match: { params },
        } = this.props;
        const queryStringParams = new URLSearchParams(search || "");
        const path = queryStringParams.toString();

        const hash = history.location.pathname.split("/");
        const hashUpper = hash[1].toUpperCase()
        const tipoProtocolo = `protocolo_${params.tipoProtocolo}`.toUpperCase();
        // if (
        //     !!modo[`protocolo_${params.tipoProtocolo}`] &&
        //     !userHasRole(ROLES[hashUpper][tipoProtocolo])
        // ) {
        //     history.push("/dashboard");
        //     return;
        // }

        const sizePerPage = await getTotaisProtocolo();
        this.setState({
            modo: modo[`protocolo_${params.tipoProtocolo}`],
            sizePerPage,
        });

        this.limparIncluidos()
        this.carregasInfos();

        if (path.length > 0) {
            window.history.pushState(
                "",
                "",
                `#/protocolo/envio/${params.tipoProtocolo}`
            );
        }
    }

    componentWillUnmount() {
        this.props.actions.clear();
    }

    limparIncluidos() {
        this.setState({ incluidos: [] });
        this.props.actions.clearIncluidos();
        this.setState({ nomeSistema: "" })
    }

    showAdicionalControlsGrid(item) {
        let show_action = false;
        let function_action = null;
        let motivo_bloqueio = "";

        switch (this.options.tipo) {
            case "protocolo_principal":
                if (item.controle && item.controle.protocolo.gerado) {
                    show_action = true;
                    motivo_bloqueio = motivos.contrato_exclusao;
                    function_action = () => this.toggleModalInsercaoBloqueio();

                    if (
                        item.controle.protocolo.enviado ||
                        item.controle.protocolo.recepcionado
                    )
                        motivo_bloqueio = motivos.ja_recepcionado;
                }

                break;
            case "protocolo_devolucao":
                if (item.controle && !item.controle.doctos.possuiDevolucao) {
                    show_action = true;
                    motivo_bloqueio = motivos.nao_pertence;
                    function_action = () => this.toggleModalInsercaoBloqueio();
                }

                break;
            default:
                break;
        }

        return (
            <div className="d-flex">
                {show_action && (
                    <Button
                        color="ghost-primary"
                        size="sm"
                        onClick={() =>
                            this.contratoBlockCallback(
                                function_action,
                                item,
                                motivo_bloqueio
                            )
                        }
                    >
                        <i className="fa fa-exclamation-triangle" />
                    </Button>
                )}
                {this.options.tipo === "protocolo_complemento" &&
                    item.controle.doctos.possuiPendencia && (
                        <Button
                            className="buttonDoc"
                            onClick={() => {
                                this.openPendencias(item);
                            }}
                            color="ghost-primary"
                            size="sm"
                        >
                            <i className="fa fa-file-image-o" />
                        </Button>
                    )}
            </div>
        );
    }

    contratoBlockCallback(func, item, motivo = "") {
        item.motivoBloqueio = motivo;
        this.setState({ contratoBloqueado: item });

        // Trigga a função do parametro
        if (typeof func === "function") {
            func();
        }
    }

    // Função responsavel por parametrizar os campos da modal de bloqueio
    adicionalActionBloqueio() {
        let button = null;

        const contrato_bloqueado = this.state.contratoBloqueado;

        if (
            this.options.tipo === "protocolo_principal" &&
            contrato_bloqueado.controle &&
            contrato_bloqueado.controle.protocolo.gerado &&
            !contrato_bloqueado.controle.protocolo.enviado &&
            !contrato_bloqueado.controle.protocolo.recepcionado
        ) {
            button = (
                <Button
                    color="btn btn-primary"
                    className="btn-primary"
                    onClick={this.redirectExclusao}
                >
                    Excluir
                </Button>
            );
        }

        return button;
    }

    encerrandoProtocolo() {
        this.toggleModalEnvelope();
        this.toggleModalProtocoloSucesso();
        const { incluidos } = this.state;
        removeFromDataByProp(
            "IdContrato",
            incluidos.map((contrato) => contrato.IdContrato)
        );
        this.limparProtocolo();
    }

    updateTrashContrato(value) {
        this.setState({
            valueContratoModal: value,
        });
        this.toggleModalContratoExcluidoSucesso();
    }

    toggleModalDevolucaoDocumentos() {
        this.setState({
            modalDevolucaoDocumentos: !this.state.modalDevolucaoDocumentos,
        });
    }

    toggleModalInsercaoBloqueio() {
        this.setState({
            modalInsercaoBloqueio: !this.state.modalInsercaoBloqueio,
        });
    }

    redirectRemoverContratoDoProtocolo() {
        redirectHandled(this.props.history, 'protocolo/excluir');
    }

    toggleModalExcluirProtocolo() {
        const { incluidos } = this.state;

        if (incluidos.length > 0) {
            this.setState({
                modalExcluirProtocolo: !this.state.modalExcluirProtocolo,
            });
        } else {
            toast.error(
                "Este protocolo não possui contratos para poder ser cancelado."
            );
        }
    }

    toggleModalProtocoloSucesso() {
        this.setState({
            modalProtocoloSucesso: !this.state.modalProtocoloSucesso,
        });
    }

    toggleModalExcluirProtocoloSucesso() {
        this.setState({
            modalExcluirProtocoloSucesso:
                !this.state.modalExcluirProtocoloSucesso,
        });
    }

    toggleModalComplementoRegularizacao() {
        this.setState({
            modalComplementoRegularizacao:
                !this.state.modalComplementoRegularizacao,
        });
    }

    toggleModalDocumentosPedentes() {
        this.setState({
            modalDocumentosPedentes: !this.state.modalDocumentosPedentes,
        });
    }

    toggleModalContratoExcluidoSucesso() {
        this.setState({
            modalContratoExcluidoSucesso:
                !this.state.modalContratoExcluidoSucesso,
        });
    }

    toggleModalEnvelope() {
        this.setState({ erroProtocolo: false });
        this.setState({
            modalEnvelope: !this.state.modalEnvelope,
        });
    }

    deleteProtocolo() {
        const { logsActions } = this.props;

        this.limparProtocolo();
        toast.success("Protocolo cancelado com sucesso!");
        this.toggleModalExcluirProtocolo();

        logsActions.registerRequest({
            service: "protocolo",
            action: LOGS.ACTIONS_TYPE.PROTOCOLO.CANCELAR,
        });
    }

    visualizarContrato(e, row) {
        const { props: { history }, state: { url } } = this;
        e.stopPropagation();
        redirectHandled(history, `${url}${row.IdContrato}`);
    }

    gridProtocoloAcoes(cell, row, items, size) {
        return (
            <div className="form-check-inline">
                <Button
                    color="ghost-primary"
                    size="sm"
                    onClick={(e) => this.visualizarContrato(e, row)}
                >
                    <i className="fa fa-eye acoes_mg_left" />
                </Button>
                <Input
                    className="form-check-input"
                    type="checkbox"
                    name="select"
                    bsSize="md"
                    style={{ position: "relative" }}
                    checked={false /*{!!row.isSelected*/}
                    disabled={true /*row.disable*/}
                />
                {this.showAdicionalControlsGrid(row)}
            </div>
        );
    }

    getDocumentosPedentes(el, row) {
        this.props.actions.documentosPendentes(
            row,
            this.openPendencias,
            (err) => toast.error(err)
        );
    }

    openPendencias(contrato) {
        this.setState({ contratoDocumentosPendentes: contrato });
        this.toggleModalDocumentosPedentes();
    }

    openDocumentos(item) {
        this.setState({ contratoDocumentosPendentes: item });
        this.toggleModalDevolucaoDocumentos();
    }

    gridProtocoloDocumentos(cell, row) {
        return (
            <div className="form-check-inline">
                <Button
                    className="buttonDoc"
                    onClick={() => {
                        this.openDocumentos(row);
                    }}
                    color="ghost-primary"
                    size="sm"
                >
                    <i className="fa fa-file-image-o" />
                </Button>
                {/* {(this.options.tipo === 'protocolo_devolucao' && row.controle.doctos.possuiDevolucao)
                    && (
                    )} */}
            </div>
        );
    }

    shouldShowProtocoloDocumentos(items = []) {
        const possuiDevolucao = items.some(
            (item) =>
                !!item.controle &&
                !!item.controle.doctos &&
                !!item.controle.doctos.possuiDevolucao
        );
        return this.options.tipo === "protocolo_devolucao" && possuiDevolucao;
    }

    onClickRemoveContrato({ IdContrato, NumeroContrato }) {
        const { actions, logsActions } = this.props;

        const contratosStorage = this.obterContratosIncluidosStorage();

        const listaContratosFiltrados = contratosStorage.filter(
            (c) => c.IdContrato !== IdContrato,
        );
        this.setarContratosIncluidosStorage(listaContratosFiltrados)

        this.setState({ incluidos: listaContratosFiltrados });

        actions.remove(IdContrato, this.options.tipo); //remover do redux envio
        removePropByProp("IdContrato", IdContrato, "isSelected");
        logsActions.registerRequest({
            service: "protocolo",
            action: LOGS.ACTIONS_TYPE.PROTOCOLO.REMOVER_CONTRATO,
            data: { id: IdContrato, contrato: NumeroContrato },
        });

        const ids = dynamicFilterStore
            .getState()
            .dynamicFilters.data.map((contrato) => contrato.IdContrato);
    }

    formatarData(cell, row) {
        let defaultValue = "";
        if (row) defaultValue = row.contrato.data;
        return defaultValue;
    }

    handleSelecionarTodos(e) {
        this._gridProtocolo.handleSelectAllRow(e);
    }

    updateEnvelopeValue(evt) {
        this.setState({
            valueEnvelope: evt.target.validity.valid
                ? evt.target.value
                : this.state.valueEnvelope,
        });
    }

    limparTudo() {
        this.props.actions.clear();
        const routePath = queryBuilder({}, "envio");
        redirectHandled(this.props.history, routePath)
    }

    limpar() {
        this.setState({
            produto: null,
            convenio: null,
            cod_promotora: null,
            cod_loja: null,
            nome_promotora: null,
        });
    }

    limparProtocolo() {
        const { history } = this.props;
        trackTime.reset(this.options.tipo);
        removePropByProp("isSelected", true, "isSelected");
        this.props.actions.clearIncluidos();
        this.setState({ valueEnvelope: "" });

        this.setarContratosIncluidosStorage([])
        this.setState({ incluidos: [] });
    }

    handleKeyPressEnvelop(event) {
        if (event.key === "Enter") {
            this.enviarProtocolo();
        }
    }

    adicionar() {
        const { actions } = this.props;
        const { sizePage, incluidos } = this.state;
        const { data, configs } = dynamicFilterStore.getState().dynamicFilters;

        let dataInclude = {};
        let dataFilter = [];

        if (incluidos && incluidos.length >= MAX_ITENS_POR_PROTOCOLO) {
            return toast.error(PROTOCOLO_ERROS_MENSAGENS.LIMITE_MAX_PROTOCOLO);
        }

        if (incluidos && incluidos.length > 0) {
            const idsContratosStorage = new Set(incluidos.map((d) => d.IdContrato));

            if (data.length > 0) {
                dataFilter = data
                    .filter((el) => el.isSelected)
                    .filter((i) => !idsContratosStorage.has(i.IdContrato));
            }

            dataInclude = [...incluidos, ...dataFilter];
        } else {
            dataInclude = data.filter((el) => el.isSelected);
        }

        actions.include(
            sizePage,
            dataInclude,
        );

        this.setarContratosIncluidosStorage(dataInclude);
        if (configs.selectAllOnGrid) selectAllOnGrid(false);
    }

    setarContratosIncluidosStorage(data) {
        const { history } = this.props;
        storage.setItem(`contratosAdicionados-${this.options.tipo}-${getSystemName(history)}`,data);
        this.setState({ incluidos: data });
    }

    redirectExclusao() {
        redirectHandled(this.props.history, `${this.state.url_exclusao}${this.contrato.value}`)
    }

    forceAdicionarContratos() {
        const docs = document.querySelectorAll(".check_documentos:checked");

        if (!docs.length) {
            toast.error("Selecione pelo menos um documento para ser enviado");
            return false;
        }

        const doc_ids = Array.from(docs).map((item) => item.value);

        const documentos = this.state.contratoDocumentosPendentes.doctos.filter(
            (documento) =>
                doc_ids.includes(documento._iddoc) ? documento : null
        );

        const payload = {
            contrato: this.state.contratoDocumentosPendentes._id,
            documentos_devolucao: documentos,
        };

        this.props.actions.forceIncludeDocumentos(payload);
        this.toggleModalDevolucaoDocumentos();
    }

    async carregasInfos() {
        this.obterNomeSistema()
        await this.obterContratosStorage();
        this.props.actions.selectsRequest();

        const { incluidos } = this.state;

        if (!!incluidos.length > 0) {
            this.adicionar();
        } else {
            trackTime.reset(this.options.tipo);
        }
    }

    obterNomeSistema() {
        const { history } = this.props;
        this.setState({ nomeSistema: getSystemName(history) })
    }
    
    obterContratosStorage() {
        const incluidosStorage = this.obterContratosIncluidosStorage();
        if (incluidosStorage) {
            this.setState({ incluidos: incluidosStorage });
        }
    }

    async enviarProtocolo() {
        if (this.state.valueEnvelope !== "") {
            this.setState({ submitProtocolotButton: true });
            this.props.actions.saveRequest(
                this.options.tipo,
                this.state.valueEnvelope,
                this.props.auth
            );
        } else {
            toast.error("Preencha o número do envelope.");
        }
        this.setState({ submitProtocolotButton: false });
    }

    async checkEnviarProtocolo() {
        if (this.state.incluidos.length > 0) {
            this.toggleModalEnvelope();
        } else {
            toast.error("Adicione pelo menos um contrato.");
        }
    }

    onPageChange(page, sizePerPage) {
        const scrollTable = document.querySelector(
            ".table-pesquisa-contratos .react-bs-container-body"
        );
        scrollTable.scrollTop = 0;
        scrollTable.scrollLeft = 0;
    }

    selectProdutos() {
        const { select_produtos } = this.props.envio;
        return select_produtos
            .filter((item) => item.text !== "null")
            .map((item) => ({
                ...item,
                label: `${item.value} - ${item.text}`,
            }));
    }

    onChangeFilterPromotora(name, value) {
        const field = dynamicFilterStore
            .getState()
            .dynamicFilters.configs.filtros.find((el) => el.name === name);
        const selectedOption = field.options.find((el) => {
            if (el.value === value) {
                return true;
            }
        });
        const getHierarquiaCadastroFilter = (hierarquia) => {
            const filter = {};
            if (!hierarquia || !hierarquia.master) return filter;
            filter["lista.hierarquiaCadastro.master.cod"] =
                hierarquia.master.cod;

            if (hierarquia.master.filial) {
                filter["lista.hierarquiaCadastro.master.filial.cod"] =
                    hierarquia.master.filial.cod;
            }

            if (!hierarquia.master.substabelecida) return filter;
            filter["lista.hierarquiaCadastro.master.substabelecida.cod"] =
                hierarquia.master.substabelecida.cod;

            if (!hierarquia.master.substabelecida.filial) return filter;
            filter[
                "lista.hierarquiaCadastro.master.substabelecida.filial.cod"
            ] = hierarquia.master.substabelecida.filial.cod;

            return filter;
        };
        updateRemoteOptionsThroughFilters(
            "codigoLoja",
            getHierarquiaCadastroFilter(selectedOption.hierarquiaCadastro[0])
        );
    }

    onChangeFilterLoja(name, value) {
        const field = dynamicFilterStore
            .getState()
            .dynamicFilters.configs.filtros.find((el) => el.name === name);
        const selectedOption = field.options.find((el) => {
            if (el.value === value) {
                return true;
            }
        });
        const getHierarquiaCadastroFilter = (hierarquia) => {
            let value;
            if (
                !!hierarquia.master &&
                !!hierarquia.master.substabelecida &&
                !!hierarquia.master.substabelecida.filial
            ) {
                value = hierarquia.master.substabelecida.filial.cod;
            }
            if (!!hierarquia.master && !!hierarquia.master.filial) {
                value = hierarquia.master.filial.cod;
            }
            if (!!hierarquia.master && !!hierarquia.master.substabelecida) {
                value = hierarquia.master.substabelecida.cod;
            }
            if (hierarquia.master) {
                value = hierarquia.master.cod;
            }
            return value ? { "lista.codigo": value } : null;
        };
        const info = !selectedOption
            ? null
            : getHierarquiaCadastroFilter(selectedOption.hierarquiaCadastro[0]);
        updateRemoteOptionsThroughFilters("codigoPromotora", info);
    }

    onChangeFilterProduto(name, value) {
        let filter;
        if (value) filter = { "lista.produtos.codigo": value };

        updateRemoteOptionsThroughFilters("convenio", filter);
    }

    onOpenProtocoloMassa() {
        this.setState({
            shouldShowProcoloMassa: true,
        });
    }

    onCloseProtocoloMassa() {
        this.setState({
            shouldShowProcoloMassa: false,
        });
    }

    obterContratosIncluidosStorage() {
        const { history } = this.props
        return storage.getItem(`contratosAdicionados-${this.options.tipo}-${getSystemName(history)}`)
    }

    onCloseErrorProtocoloMassa() {
        let incluidosStorage = this.obterContratosIncluidosStorage();
        const ids = new Set(this.props.envio.protocolo_massa_erros.map((d) => d.IdContrato));
        let incluidosValidos = incluidosStorage.filter((i) => !ids.has(i.IdContrato));
        this.setarContratosIncluidosStorage(incluidosValidos)
        this.props.envio.incluidos = incluidosValidos
        const { protocoloMassaClose } = this.props.actions;
        protocoloMassaClose();
        this.setState({
            shouldShowProcoloMassa: false,
        });
        this.carregasInfos()
    }

    onValidateProtocoloMassa(numeros_dossies) {
        const { protocoloMassaRequest } = this.props.actions;
        protocoloMassaRequest(
            this.options.tipo, 
            { numeros_dossies },
            this.state.nomeSistema
        );
    }

    modalProtocoloPrincipalJaExiste(e, row) {
        this.setState({ contratoBloqueado: row });
        this.toggleModalInsercaoBloqueio();
    }

    removerContratoDoProtocolo() {
        this.props.excluirActions.removerContratoDoProtocolo(
            this.state.contratoBloqueado,
            () => {
                removeFromDataByProp("IdContrato", [
                    this.state.contratoBloqueado.IdContrato,
                ]);
                toast.success(
                    "Aguarde a notificação de exclusão do protocolo."
                );
            },
            (err) =>
                toast.error(
                    `Erro ao remover contrato ${this.state.contratoBloqueado.NumeroContrato}. ${err.message}`
                )
        );
        this.toggleModalConfirmarRemoverContratoDoProtocolo();
    }

    customActions() {
        let tableActions = [
            {
                icon: "fa fa-eye acoes_mg_left",
                action: (e, row) => this.visualizarContrato(e, row),
                buttonColor: "ghost-primary",
            },
        ];
        switch (this.props.match.params.tipoProtocolo) {
            case "principal":
                tableActions = [
                    ...tableActions, 
                    ...[
                        {
                            type: "checkbox",
                            checked: (row) => row.isSelected,
                            disabled: (row) => row.TipoSituacao !== "NAOPROTOCOLADO",
                        },
                        {
                            icon: "fa fa-exclamation-triangle",
                            action: (e, row) =>
                                this.modalProtocoloPrincipalJaExiste(e, row),
                            buttonColor: "ghost-primary",
                            show: (row) => row.TipoSituacao !== "NAOPROTOCOLADO",
                        }
                    ]
                ];
                break;
            case "complemento":
                tableActions = [
                    ...tableActions, 
                    ...[{
                        type: "checkbox",
                        checked: (row) => row.isSelected,
                        disabled: (row) => row.TipoSituacao === "NAOPROTOCOLADO",
                    },
                    {
                        icon: "fa fa-file-image-o ",
                        action: (e, row) => this.getDocumentosPedentes(e, row),
                        buttonColor: "ghost-primary",
                        show: (row) => row.TemPendencia,
                    }]
                ];
                break;
            case "cancelado":
                tableActions = [
                    ...tableActions, 
                    ...[{
                        type: "checkbox",
                        checked: (row) => row.isSelected,
                    }
                    // {
                    //     icon: "fa fa-file-image-o ",
                    //     action: (e, row) => this.getDocumentosPedentes(e, row),
                    //     buttonColor: "ghost-primary",
                    //     show: (row) => row.TemPendencia,
                    // }
                    ]
                ];
                break;
            case "consignado":
                break;
        }
        return tableActions;
    }

    gridCestaAcoes() {
        return [
            {
                icon: "fa fa-eye acoes_mg_left",
                action: (e, row) => this.visualizarContrato(e, row),
                buttonColor: "ghost-primary",
            },
            {
                icon: "fa fa fa-trash acoes_mg_left",
                action: (e, row) => this.onClickRemoveContrato(row),
                buttonColor: "ghost-danger",
            },
        ];
    }

    redirectExcluirProtocolo() {
        const { contratoBloqueado } = this.state;
        redirectHandled(this.props.history, `/protocolo/excluir`);
    }

    render() {
        const fieldsChange = {
            codigoProtomora: this.onChangeFilterPromotora,
            codigoLoja: this.onChangeFilterLoja,
            produto: this.onChangeFilterProduto,
        };

        const { data } = dynamicFilterStore.getState().dynamicFilters;
        const { incluidos } = this.state;
        const { shouldShowProcoloMassa } = this.state;

        const tipo =
            this.options.tipo !== undefined && this.options.tipo !== ""
                ? this.options.tipo
                : "principal";

        return (
            <ContextLoader isLoading={this.props.envio.loading}>
                <div>
                    <ModalExclusaoSucesso
                        isOpen={this.state.modalContratoExcluidoSucesso}
                        toggle={this.toggleModalContratoExcluidoSucesso}
                        numeroContrato={this.state.valueContratoModal}
                    />

                    <ModalConfirmarExclusao
                        isOpen={this.state.modalExcluirProtocolo}
                        toggle={this.toggleModalExcluirProtocolo}
                        confirmar={this.deleteProtocolo}
                    />

                    <ModalConfirmarRemoverContratoDoProtocolo
                        contratoBloqueado={this.state.contratoBloqueado}
                        isOpen={
                            this.state.modalConfirmarRemoverContratoDoProtocolo
                        }
                        toggle={this.redirectRemoverContratoDoProtocolo}
                        confirmar={this.removerContratoDoProtocolo}
                    />
                    <ModalEnviarProtocolo
                        isOpen={this.state.modalEnvelope}
                        toggle={this.toggleModalEnvelope}
                        envelope={{
                            value: this.state.valueEnvelope,
                            onChange: this.updateEnvelopeValue,
                            onKeyPress: this.handleKeyPressEnvelop,
                        }}
                        confirmar={{
                            disabled: this.state.submitProtocolotButton,
                            onClick: this.enviarProtocolo,
                        }}
                    />
                    <ModalDocumentosPendentes
                        contrato={this.state.contratoDocumentosPendentes}
                        isOpen={this.state.modalDocumentosPedentes}
                        toggle={this.toggleModalDocumentosPedentes}
                    />

                    <ModalProtocoloInvalido
                        isOpen={this.state.modalInsercaoBloqueio}
                        toggle={this.toggleModalInsercaoBloqueio}
                        contratoBloqueado={this.state.contratoBloqueado}
                        confirmarExclusao={this.redirectExcluirProtocolo}
                    />

                    <ModalProtocoloExcluidoSucesso
                        isOpen={this.state.modalExcluirProtocoloSucesso}
                        toggle={this.toggleModalExcluirProtocoloSucesso}
                    />

                    <ModalGeracaoProtocolo
                        isOpen={this.state.modalProtocoloSucesso}
                        toggle={this.toggleModalProtocoloSucesso}
                        erroProtocolo={this.state.erroProtocolo}
                        imprimirProtocolo={this.props.envio.redirectImpressao}
                        numeroProtocoloGerado={
                            this.props.envio.protocoloFinalizadoNumero
                        }
                    />
                </div>
                <Row>
                    <Col
                        sm={12}
                        md={9}
                        style={{ flexBasis: "auto", paddingBottom: "1.5rem" }}
                    >
                        <Card className="default-card-height">
                            <CardHeader>
                                <i className="icon-note" />
                                <strong>
                                    Protocolo - {modo[tipo].title}
                                </strong>{" "}
                            </CardHeader>
                            <CardBody>
                                <FiltroDinamico
                                    {...this.props}
                                    onChangeInputs={fieldsChange}
                                    name={`protocolo-finame-${this.props.match.params.tipoProtocolo}`}
                                    service="protocolo-finame"
                                    actionsButtons={{
                                        protocoloEmMassa:
                                            this.onOpenProtocoloMassa,
                                        adicionar: this.adicionar,
                                    }}
                                />
                            </CardBody>
                        </Card>
                    </Col>

                    <Col sm={12} md={3} style={{ flexBasis: "auto" }}>
                        <Card>
                            <CardHeader>
                                <i className="icon-note" />
                                <strong>
                                    Total de{" "}
                                    {incluidos.length > 1
                                        ? modo[tipo].colunaResultPlural
                                        : modo[tipo].colunaResult}{" "}
                                    {incluidos.length}
                                </strong>{" "}
                            </CardHeader>
                            <CardBody>
                                <Row className="row_protocolo">
                                    <Col>
                                        <GridDinamico
                                            name="cesta"
                                            data={incluidos}
                                            pagination={false}
                                            tableActions={this.gridCestaAcoes()}
                                            height="350"
                                            maxHeight="350"
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="d-flex mt-3">
                                        <Button
                                            className="btn btn_success flex-fill"
                                            onClick={this.checkEnviarProtocolo}
                                        >
                                            Finalizar
                                        </Button>
                                        <Button
                                            className="btn btn_danger flex-fill"
                                            onClick={
                                                this.toggleModalExcluirProtocolo
                                            }
                                        >
                                            Cancelar
                                        </Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={12} style={{ flexBasis: "auto" }}>
                        <Card>
                            <CardHeader>
                                <i className="icon-note" />
                                <strong>Listagem de Contratos</strong>{" "}
                            </CardHeader>
                            <CardBody>
                                <Row
                                    className={`mt-3 row_protocolo table-pesquisa-contratos ${
                                        data &&
                                        incluidos &&
                                        data.length - incluidos.length > 0
                                            ? "fixed-width"
                                            : "auto-width"
                                    }`}
                                >
                                    <GridDinamico
                                        filterFunction={(row) => !incluidos.some(contrato => contrato.IdContrato === row.IdContrato )}
                                        tableActions={this.customActions()}
                                        height="100%"
                                        maxHeight="346"
                                    />
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <ProtocoloMassa
                    isOpen={shouldShowProcoloMassa}
                    onClose={this.onCloseProtocoloMassa}
                    onCloseError={this.onCloseErrorProtocoloMassa}
                    onValidate={this.onValidateProtocoloMassa}
                />
            </ContextLoader>
        );
    }
}

const mapStateToProps = (state) => ({
    envio: state.protocoloEnvio,
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(EnvioActions, dispatch),
    authActions: bindActionCreators(authActions, dispatch),
    logsActions: bindActionCreators(logsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnvioFiname);
